import { useCrud } from '@next-qr/lib-ui/hooks';
import type { CrudListOptions, CrudGetOptions } from '@next-qr/lib-ui/hooks/useCrud';
import { planApi, subscriptionApi } from './api';

export interface Plan {
  id: number;
  name: string;
  slug: string;
  description: string;
  price_monthly: number;
  price_yearly: number;
  features: Record<string, unknown>;
}

export interface Subscription {
  id: number;
  [key: string]: unknown;
}

const planCrud = useCrud<Plan>(planApi);

export const usePlanList   = (options?: CrudListOptions) => planCrud.useList({ ...options, subscriptionFn: planApi.subscribe });
export const usePlan       = (id: string | number, options?: CrudGetOptions) => planCrud.useGet(id, { ...options, subscriptionFn: planApi.subscribe });
export const useCreatePlan = (options?: Parameters<typeof planCrud.useCreate>[0]) => planCrud.useCreate(options);
export const useUpdatePlan = (options?: Parameters<typeof planCrud.useUpdate>[0]) => planCrud.useUpdate(options);
export const useRemovePlan = (options?: Parameters<typeof planCrud.useRemove>[0]) => planCrud.useRemove(options);

const subCrud = useCrud<Subscription>(subscriptionApi);

export const useSubscriptionList   = (options?: CrudListOptions) => subCrud.useList({ ...options, subscriptionFn: subscriptionApi.subscribe });
export const useSubscription       = (id: string | number, options?: CrudGetOptions) => subCrud.useGet(id, { ...options, subscriptionFn: subscriptionApi.subscribe });
export const useCreateSubscription = (options?: Parameters<typeof subCrud.useCreate>[0]) => subCrud.useCreate(options);
export const useUpdateSubscription = (options?: Parameters<typeof subCrud.useUpdate>[0]) => subCrud.useUpdate(options);
export const useRemoveSubscription = (options?: Parameters<typeof subCrud.useRemove>[0]) => subCrud.useRemove(options);
